import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { formatToCurrency } from "shared/utils";
import { Unit } from "types/landlord/address";
import { UnitCardField } from "../../visibilityConstants";
import { UnitActivityPill } from "./UnitActivityPill";
import { UnitCoverPhoto } from "./UnitCoverPhoto";
import { UnitLockboxPill } from "./UnitLockboxPill";
import { NeedsLockboxBadge } from "../NeedsLockboxBadge";

const coverPhotoUrl = (unit: Unit) => {
  const variants = unit.primary_image_url;
  if (!variants) return null;

  return (
    variants.small || variants.medium || variants.large || variants.full || null
  );
};

export const UnitCardPhoto = ({
  unit,
  shows,
  onActivityClick
}: {
  unit: Unit;
  shows: (field: string) => boolean;
  onActivityClick: (unit: Unit) => void;
}) => {
  const newActivityCount = unit.new_activity_count ?? 0;
  const showsActivity = newActivityCount > 0 && shows(UnitCardField.Activity);

  return (
    <div className="relative">
      <UnitCoverPhoto url={coverPhotoUrl(unit)} alt={unit.title} />

      <Show
        if={
          Boolean(unit.monthly_rent_amount?.cents) && shows(UnitCardField.Rent)
        }
      >
        <span className="absolute left-3 top-4 rounded-lg bg-content-1000 px-2 py-1.5 text-sm font-bold text-content-1000-inverted shadow-2xl">
          {formatToCurrency(unit.monthly_rent_amount ?? null)}
        </span>
      </Show>

      <div className="absolute inset-x-3 bottom-3 flex items-center justify-between gap-2">
        <span className="flex items-center gap-2">
          <Show if={showsActivity}>
            <UnitActivityPill
              count={newActivityCount}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onActivityClick(unit);
              }}
            />
          </Show>
          <Show if={shows(UnitCardField.CurrentStatus)}>
            <Badge
              variant={
                unit.occupied ? BadgeVariant.PRIMARY : BadgeVariant.SUCCESS
              }
              size={BadgeSize.BASE}
            >
              {unit.occupied ? "Occupied" : "Available"}
            </Badge>
          </Show>
        </span>

        <Show if={shows(UnitCardField.Lockbox)}>
          {unit.needs_lockbox ? (
            <NeedsLockboxBadge className="shadow-sm" />
          ) : (
            <UnitLockboxPill lockboxStatus={unit.lockbox_status} />
          )}
        </Show>
      </div>
    </div>
  );
};
